if (!customElements.get('akon-projects')) {
  customElements.define('akon-projects', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const on = (el, type, handler) => el?.addEventListener(type, handler, { signal: this.abort.signal });
      const normalize = (text) => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const cards = [...this.querySelectorAll('.tp-centros__item')];
      const track = this.querySelector('.tp-centros__grid');
      const category = this.querySelector('select[data-project-category]');
      const search = this.querySelector('input[data-project-search]');
      if (category) {
        while (category.options.length > 1) category.remove(1);
        [...new Set(cards.map((card) => card.dataset.projectCategory).filter(Boolean))].sort().forEach((name) => category.add(new Option(name, name)));
      }
      const filter = () => {
        cards.forEach((card) => { card.hidden = Boolean(category?.value && card.dataset.projectCategory !== category.value) || !normalize(card.dataset.projectSearch).includes(normalize(search?.value || '')); });
        const empty = this.querySelector('[data-project-empty]');
        if (empty) empty.hidden = cards.some((card) => !card.hidden);
        if (track) track.scrollLeft = 0;
        update();
      };
      const update = () => {
        const prev = this.querySelector('[data-project-prev]');
        const next = this.querySelector('[data-project-next]');
        if (prev) prev.disabled = !track || track.scrollLeft < 2;
        if (next) next.disabled = !track || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const scroll = (direction) => {
        const card = cards.find((item) => !item.hidden);
        track?.scrollBy({left: direction * ((card?.getBoundingClientRect().width || track.clientWidth) + 20), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      on(search, 'input', filter);
      on(category, 'change', filter);
      on(track, 'scroll', update);
      on(this.querySelector('[data-project-prev]'), 'click', () => scroll(-1));
      on(this.querySelector('[data-project-next]'), 'click', () => scroll(1));
      cards.forEach((card) => {
        const dialog = card.querySelector('dialog');
        if (!dialog) return;
        const photos = dialog.querySelector('.akon-projects__photos');
        const open = card.querySelector('[data-project-open]');
        const updatePhotos = () => {
          const index = Math.round(photos.scrollLeft / (photos.clientWidth || 1));
          dialog.querySelector('[data-photo-count]').textContent = `${index + 1} / ${photos.children.length}`;
          dialog.querySelector('[data-photo-prev]').disabled = index === 0;
          dialog.querySelector('[data-photo-next]').disabled = index >= photos.children.length - 1;
        };
        on(open, 'click', () => { dialog.showModal(); photos.scrollLeft = 0; updatePhotos(); });
        on(dialog.querySelector('[data-project-close]'), 'click', () => dialog.close());
        on(dialog, 'close', () => open.focus({preventScroll:true}));
        on(dialog, 'click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        on(photos, 'scroll', updatePhotos);
        on(dialog.querySelector('[data-photo-prev]'), 'click', () => photos.scrollBy({left: -photos.clientWidth}));
        on(dialog.querySelector('[data-photo-next]'), 'click', () => photos.scrollBy({left: photos.clientWidth}));
        on(dialog, 'keydown', (event) => {
          if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          photos.scrollBy({left: photos.clientWidth * (event.key === 'ArrowLeft' ? -1 : 1)});
        });
      });
      this.resize = new ResizeObserver(update);
      if (track) this.resize.observe(track);
      on(document, 'shopify:block:select', (event) => {
        const card = event.target.closest('.tp-centros__item');
        if (!card || !this.contains(card)) return;
        if (search) search.value = '';
        if (category) category.value = '';
        filter();
        card.scrollIntoView({block:'nearest', inline:'center'});
      });
      update();
    }
    disconnectedCallback() {
      this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
      this.abort?.abort();
      this.resize?.disconnect();
    }
  });
}
